import React from 'react';
import './style.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="footer-container">
      <div className="footer-bottom-container">
        <div className="container">
          <div className="row">
            <div className="col-12 container-social-media-footer">
              <a href="https://www.facebook.com/OPUniversitaire.dz/" target="_blank" rel="noreferrer">
                <img className="icon-follow-us-footer" src="/assets/images/icons/facebook.svg" alt="facebook" />
              </a>
              <a href="https://www.instagram.com/opuniversitaire.dz/" target="_blank" rel="noreferrer">
                <img className="icon-follow-us-footer" src="/assets/images/icons/instagram.svg" alt="instagram" />
              </a>
              <a
                href="https://www.linkedin.com/in/office-des-publications-universitaires-80a181221/"
                target="_blank"
                rel="noreferrer"
              >
                <img className="icon-follow-us-footer" src="/assets/images/icons/linkedin.svg" alt="linkedin" />
              </a>
              <a href="https://www.youtube.com/channel/UCJRAqUw34L8bGmF43J3avog" target="_blank" rel="noreferrer">
                <img className="icon-follow-us-footer" src="/assets/images/icons/youtube.svg" alt="youtube" />
              </a>
            </div>
          </div>
        </div>
        <div className="container pt-2">
          <div>{t('footer.copyright')}</div>
          <div className="footer-app-link">
            <Link to="/app">{t('header.app')}</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
